module.exports = __webpack_public_path__ + "static/media/BA.7c65bc41.svg";